export { default } from './WorkplaceChallengesView';



// WEBPACK FOOTER //
// ./src/components/views/WorkplaceChallengesView/index.js